import React from "react";

export default function MessageComposer({
  userData,
  messageValue,
  showDrop,
  onToggleDrop,
  onMessageChange,
  onKeyPress,
  onSubmit,
  onImageUpload,
  onFileUpload,
}) {
  if (!userData?.id || userData?.status === "completed") {
    return null;
  }

  return (
    <div className="messaging__chat-bottom">
      {showDrop && (
        <div className="messaging__chat-drop">
          <div className="messaging__chat-dropItem">
            <input
              accept=".mp4, .jpg, .jpeg, .png"
              id="image-upload"
              type="file"
              onChange={onImageUpload}
            />
            <label htmlFor="image-upload">
              <span>
                <img src="/assets/icons/photo-icon.svg" alt="" />
              </span>
              <p>Photo or video</p>
            </label>
          </div>
          <div className="messaging__chat-dropItem">
            <input
              accept=".xlsx, .xls, .doc, .docx, .ppt, .pptx, .txt, .pdf, .csv, text/csv"
              id="file-upload"
              type="file"
              onChange={onFileUpload}
            />
            <label htmlFor="file-upload">
              <span>
                <img src="/assets/icons/file-icon.svg" alt="" />
              </span>
              <p>File</p>
            </label>
          </div>
        </div>
      )}
      <form action="">
        <div className="messaging__chat-textarea">
          <textarea
            onKeyPress={onKeyPress}
            placeholder="Type a message..."
            onChange={(event) => onMessageChange(event.target.value)}
            value={messageValue}
          ></textarea>
          {messageValue.length === 0 && (
            <div onClick={onToggleDrop} className="messaging__chat-image">
              <img
                src={`/assets/icons/${showDrop ? "skrepka-blue" : "skrepka"}.svg`}
                alt=""
              />
            </div>
          )}
        </div>
        <div
          onClick={onSubmit}
          className={`messaging__chat-btn ${
            messageValue.length === 0 ? "messaging__chat-btn_none" : ""
          }`}
        >
          <img src="/assets/icons/enter.svg" alt="enter" />
        </div>
      </form>
    </div>
  );
}
